module.exports = __webpack_public_path__ + "ca21d827493990804bed2bf97ef334ad.woff2";